import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

export const DataGrableLoading = () => {
  return (
    <div className="ag-overlay-loading-center">
      <div className="ag-overlay-loading-rows">
        {[...Array(10)].map((_, index) => (
          <Skeleton key={index} height={38} />
        ))}
      </div>
    </div>
  );
};
